export default [
  // Main Page
  {
    path: 'sales-reports',
    name: 'website.sales-reports',
    component: () => import('@/views/website/sales-reports'),
  },
];
